import 'ol/ol.css';
import Map from 'ol/Map';
import View from 'ol/View';
import XYZ from 'ol/source/XYZ';
import VectorSource from 'ol/source/Vector';
import Feature from 'ol/Feature';
import Polygon from 'ol/geom/Polygon';
import Circle from 'ol/geom/Circle';
import {Tile as TileLayer, Vector as VectorLayer} from 'ol/layer';
import {Circle as CircleStyle, Fill, Stroke, Style, Icon} from 'ol/style';
import {createEmpty, extend} from 'ol/extent';
import Projection from 'ol/proj/Projection';
import fileDownload from 'js-file-download';
import { DragAndDrop, defaults as defaultInteractions, } from 'ol/interaction';
import {GPX, GeoJSON, IGC, KML, TopoJSON} from 'ol/format';
import Point from 'ol/geom/Point';
import Geometry from 'ol/geom/Geometry';
import {transform} from 'ol/proj';
import * as olCoordinate from 'ol/coordinate';
import ScaleLine from 'ol/control/ScaleLine';
import Control from 'ol/control/Control';


class Carte {
    image = null;
    styles = null;
    map = null;

    constructor() {
        var t = this;
        this.map = null;
    }

    chargementCarte(map_html = 'map') {
        var t = this;
        var params = {
            target: map_html,
            layers: [
                new TileLayer({
                    source: new XYZ({
                        url: 'https://{a-c}.tile.openstreetmap.org/{z}/{x}/{y}.png',
                        crossOrigin: "Anonymous"
                    })
                }),
            ],
            view: new View({
                projection: 'EPSG:3857',
                center: [0, 0],
                zoom: 5,
                showFullExtent: true
            })
        };
        t.map = new Map(params);
        t.map.addControl(new ScaleLine({ units: 'metric' }));

        // Live viewport-width readout in the bottom-right corner
        var vpEl = document.createElement('div');
        vpEl.className = 'ol-viewport-width ol-unselectable';
        Object.assign(vpEl.style, {
            position: 'absolute', bottom: '8px', right: '8px',
            padding: '2px 6px', background: 'rgba(255,255,255,0.75)',
            border: '1px solid #bbb', borderRadius: '3px',
            fontSize: '11px', lineHeight: '1.5', pointerEvents: 'none'
        });
        var updateVp = function () {
            var res = t.map.getView().getResolution();
            var sz  = t.map.getSize();
            if (!res || !sz) return;
            var m = res * sz[0];
            vpEl.textContent = m >= 1000
                ? '\u2194 ~' + (m / 1000).toFixed(1) + ' km'
                : '\u2194 ~' + Math.round(m) + ' m';
        };
        t.map.addControl(new Control({ element: vpEl }));
        t.map.getView().on('change:resolution', updateVp);
        t.map.on('change:size', updateVp);
        updateVp();

        return t.map;
    }

    async kmltogeojson(map, url = null, callback) {
        var t = this;

        var vectorLayer = new VectorLayer({
            source: new VectorSource({
                url: "/storage/" + url,
                format: new KML(),
            })
        });
        map.addLayer(vectorLayer);

        setTimeout(function () {
            var format = new GeoJSON({
                'maxDepth': 10,
                'extractStyles': true,
                'externalProjection': new Projection("EPSG:4326")
            });
            var features = vectorLayer.getSource().getFeatures();
            var file = format.writeFeatures(features, {
                featureProjection: map.getView().getProjection()
            });

            callback(file);
        }, 2000);
    }

    async impacttogeojson(map, coordonnees = null, callback) {

        var jsonCoordonnes = JSON.parse(coordonnees);
        var nombreCoordonnee = jsonCoordonnes[0].length;
        var typeGeom = "Polygon";
        if(nombreCoordonnee == 1){
            var typeGeom = "Point";

            var result = coordonnees.slice(3,-3);

            jsonCoordonnes = JSON.parse(result);

        }else if(nombreCoordonnee > 1){
        
            var itemDebut = jsonCoordonnes[0][0];
            var itemFin = jsonCoordonnes[0][nombreCoordonnee - 1];

            if(itemDebut[0] != itemFin[0] && itemDebut[1] != itemFin[1]){
                //C'est une ligne
                typeGeom = "LineString";
            }

        }
            var geoJSON = {
                "type": "Feature",
                "properties": {
                    "id": "shape"
                },
                "geometry": {
                    "type": typeGeom,
                    "coordinates": jsonCoordonnes
                }
            };
            const vectorSource = new VectorSource({
                features: new GeoJSON().readFeatures(geoJSON),
            });

            var fill = new Fill({
                color: [7, 114, 64, 0.2],
            });
            var stroke = new Stroke({
                color: "#077240",
                width: 2,
            });
            var styles = new Style({
                    image: new CircleStyle({
                    fill: fill,
                    stroke: stroke,
                    radius: 10,
                }),
                fill: fill,
                stroke: stroke
            });

            const vectorLayer = new VectorLayer({
                source: vectorSource,
                style: [styles]
            });
            map.addLayer(vectorLayer);
            setTimeout(function () {
            var format = new GeoJSON({
                'maxDepth': 10,
                'extractStyles': true,
                'externalProjection': new Projection("EPSG:4326")
            });
            var features = vectorLayer.getSource().getFeatures();
            var file = format.writeFeatures(features, {
                featureProjection: new Projection("EPSG:4326")
            });
            callback(file);
        }, 2000);
    }



/*
    async chargementKml(map, carnet_id = null, operation_id = null) {
        var t = this;

        var route_url = "";
        if (carnet_id != null) {
            route_url = route('carnet.kmls', carnet_id);
        } else if (operation_id != null) {
            route_url = route('carnet.kmls.operation', operation_id);
        }

        var extent = createEmpty();
        $.ajax({
            url: route_url,
            data: {
                "_token": $('meta[name=csrf-token]').attr("content")
            },
            type: 'POST',
            success: function (data) {
                $.each(data, function (i, item) {
                    var vectorLayer = new VectorLayer({
                        source: new VectorSource({
                            url: "/storage/" + item.url,
                            format: new KML(),
                        })
                    });
                    map.addLayer(vectorLayer);
                    t.extendSource(map, vectorLayer, extent);
                });
            }
        });
    }*/

    async chargementGeometries(map, carnet_id = null, operation_id = null, membre_id = null, geometries = false, operation_actif = null, autoFit = true) {

        var t = this;

        var fill = new Fill({
            color: [7, 114, 64, 0.2],
        });
        if(operation_actif == null){
            var stroke = new Stroke({
                color: "#077240",
                width: 2,
            });
                
        }else{
            if(operation_actif == true){
                var stroke = new Stroke({
                    color: "#1212db",
                    width: 2,
                });                
            }else{
                var stroke = new Stroke({
                    color: "#999999",
                    width: 2,
                });                 
            }

        }

        var styles = new Style({
            image: new CircleStyle({
                fill: fill,
                stroke: stroke,
                radius: 10,
            }),
            fill: fill,
            stroke: stroke
        });

        var vectorSource = new VectorSource();
        var vectorLayer = new VectorLayer({
            source: vectorSource,
            style: [styles]
        });

        var route_url = "";
        if (geometries == true) {
            route_url = route('carnets.geometries');
        } else if (membre_id != null) {
            route_url = route('carnet.geometrie.membre', membre_id);
        } else if (carnet_id != null) {
            route_url = route('carnet.geometrie', carnet_id);
        } else if (operation_id != null) {
            route_url = route('carnet.geometrie.operation', operation_id);
        }

        var extent = createEmpty();
        if (autoFit) {
            t.extendSource(map, vectorLayer, extent);
        }
        map.addLayer(vectorLayer);

        $.ajax({
            url: route_url,
            method: 'GET',
            success: function (data) {
                // Build all OL features first, then add in one batch so that the
                // VectorSource fires a single 'change' event AFTER all features
                // are present. Individual addFeature() calls fire 'change' per
                // call, causing the Promise below to resolve with only 1 feature.
                var featuresArr = [];
                $.each(data, function (i, item) {
                    var feature = new GeoJSON({dataProjection: 'EPSG:4326', featureProjection: 'EPSG:3857'}).readFeature(item);
                    feature.setProperties(item.properties);
                    featuresArr.push(feature);
                });
                vectorSource.addFeatures(featuresArr);
            }
        });

        var source = vectorLayer.getSource();

        return new Promise((resolve, reject) => {
            source.once('change',function(e){
                if (source.getState() === 'ready') {
                    var features = source.getFeatures();
                    resolve(features);
                }
            });
        });
    }

    async chargementDepots(map) {
        var t = this;

        var fill = new Fill({
            color: [0, 74, 173, 0.2],
        });
        var stroke = new Stroke({
            color: "#004aad",
            width: 2,
        });
        var styles = new Style({
            image: new CircleStyle({
                fill: fill,
                stroke: stroke,
                radius: 10,
            }),
            fill: fill,
            stroke: stroke
        });

        var vectorSource = new VectorSource();
        var vectorLayer = new VectorLayer({
            source: vectorSource,
            style: styles
        });

        $.ajax({
            url: route('depots.geometries'),
            method: 'GET',
            success: function (data) {
                $.each(data, function (i, item) {
                    var markerFeature = new Feature({
                        geometry: new Point(transform(item, 'EPSG:4326', 'EPSG:3857'))
                    });
                    vectorSource.addFeature(markerFeature);
                });
                map.addLayer(vectorLayer);
            }
        });
    }

    extendSource(map, vectorLayer, extent) {
        var t = this;
        var vectorSource = vectorLayer.getSource();
        vectorSource.once('change', function (e) {
            if (vectorSource.getState() === 'ready') {
                extend(extent, vectorSource.getExtent());
                t.extendCarte(map, extent);
            }
        });
    }

    extendCarte(map, extent) {
        map.getView().fit(extent);
        map.getView().changed();
        if (map.getView().getZoom() > 15) {
            map.getView().setZoom(15);
        }
    }

    fitFeature(map, feature) {
        var extent = feature.getGeometry().getExtent();
        map.getView().fit(extent, {
            padding: [50, 50, 50, 50],
            maxZoom: 15,
            duration: 500
        });
    }

    fitMapToAllLayers(map) {
        var t = this;
        var combinedExtent = createEmpty();
        var hasGeometries = false;

        // Iterate through all vector layers on the map
        map.getLayers().forEach(function (layer) {
            if (layer instanceof VectorLayer) {
                var source = layer.getSource();
                if (source && source.getFeatures && source.getFeatures().length > 0) {
                    var layerExtent = source.getExtent();
                    if (layerExtent && layerExtent !== null && layerExtent.some(coord => !isNaN(coord))) {
                        extend(combinedExtent, layerExtent);
                        hasGeometries = true;
                    }
                }
            }
        });

        // If we have geometries, fit the map to show all of them
        if (hasGeometries) {
            // Add some padding and set maximum zoom
            map.getView().fit(combinedExtent, {
                padding: [20, 20, 20, 20], // Add 20px padding around geometries
                maxZoom: 15, // Don't zoom closer than level 15
                duration: 1000 // Smooth transition over 1 second
            });
        }
    }

    /**
     * Fit the initial map view to the densest cluster of features, so when parcels
     * are geographically far apart the map doesn't zoom out to a useless world view.
     *
     * Algorithm:
     *  1. Probe the zoom level for the combined extent of all features.
     *  2. If zoom >= minZoom all parcels are already close enough – delegate to fitMapToAllLayers.
     *  3. Otherwise sort features by distance to their collective centroid and add
     *     them one-by-one (closest first) as long as the resulting extent still
     *     stays at or above minZoom. Fit the map to that subset.
     *
     * The dropdown navigator is unchanged and still lists every parcel, so outliers
     * remain reachable even when not shown in the initial view.
     *
     * @param {ol/Map} map
     * @param {ol/Feature[]} features  All loaded parcel features.
     * @param {number} minZoom         Minimum acceptable zoom level (default 10, ~40 km viewport).
     */
    fitMapToFocusCluster(map, features, minZoom = 10) {
        var t = this;

        if (!features || features.length === 0) {
            t.fitMapToAllLayers(map);
            return;
        }

        // Compute the center point (EPSG:3857) of each feature's bounding box
        var centers = features.map(function (feature) {
            var ext = feature.getGeometry().getExtent();
            return [(ext[0] + ext[2]) / 2, (ext[1] + ext[3]) / 2];
        });

        // Overall centroid of all feature centers
        var cx = centers.reduce(function (s, c) { return s + c[0]; }, 0) / centers.length;
        var cy = centers.reduce(function (s, c) { return s + c[1]; }, 0) / centers.length;

        // Sort features ascending by distance to centroid
        var sorted = features.map(function (f, i) {
            var dx = centers[i][0] - cx;
            var dy = centers[i][1] - cy;
            return { feature: f, dist: Math.sqrt(dx * dx + dy * dy) };
        });
        sorted.sort(function (a, b) { return a.dist - b.dist; });
        sorted = sorted.map(function (item) { return item.feature; });

        // Helper: compute the projected zoom level for a given extent without animating
        var probeZoom = function (ext) {
            var size = map.getSize();
            if (!size || size[0] === 0 || size[1] === 0) return minZoom; // safe fallback
            var padding = 20;
            var paddedSize = [Math.max(1, size[0] - 2 * padding), Math.max(1, size[1] - 2 * padding)];
            var resolution = map.getView().getResolutionForExtent(ext, paddedSize);
            return map.getView().getZoomForResolution(resolution);
        };

        // Check if showing every feature is already acceptable
        var allExtent = createEmpty();
        features.forEach(function (f) { extend(allExtent, f.getGeometry().getExtent()); });
        if (probeZoom(allExtent) >= minZoom) {
            t.fitMapToAllLayers(map);
            return;
        }

        // Build the closest-first subset that still respects minZoom
        var subsetExtent = createEmpty();
        extend(subsetExtent, sorted[0].getGeometry().getExtent());
        for (var i = 1; i < sorted.length; i++) {
            var candidate = createEmpty();
            extend(candidate, subsetExtent);
            extend(candidate, sorted[i].getGeometry().getExtent());
            if (probeZoom(candidate) < minZoom) break;
            subsetExtent = candidate;
        }

        map.getView().fit(subsetExtent, {
            padding: [20, 20, 20, 20],
            maxZoom: 15,
            duration: 1000
        });
    }

    /*
     carteExtent(vectorLayer, map, onChange = false) {
     var t = this;
     if (onChange === false) {
     t.extent(vectorLayer, map);
     } else {
     var vectorSource = vectorLayer.getSource();
     vectorSource.once('change', function (e) {
     if (vectorSource.getState() === 'ready') {
     t.extent(vectorLayer, map, false);
     }
     });
     }
     }
     
     extent(vectorLayer, map) {
     var source = vectorLayer.getSource();
     var features = source.getFeatures();
     var extent = createEmpty();
     if (features) {
     features.forEach(function (feature) {
     console.log(feature);
     extend(extent, feature.getGeometry().getExtent());
     });
     }
     if (extent) {
     map.getView().fit(extent, map.getSize());
     map.getView().changed();
     if (map.getView().getZoom() > 15) {
     map.getView().setZoom(15);
     }
     }
     
     }*/
}

export { Carte  };


